import { render } from "./playerProgressBar.vue?vue&type=template&id=884b0916&scoped=true"
import script from "./playerProgressBar.vue?vue&type=script&lang=js"
export * from "./playerProgressBar.vue?vue&type=script&lang=js"

import "./playerProgressBar.vue?vue&type=style&index=0&id=884b0916&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884b0916"]])

export default __exports__